import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { BookOpen } from "lucide-react";

export default function DailyVerse() {
  const [verse, setVerse] = useState(null);
  useEffect(() => { api.get("/daily-verse").then((r) => setVerse(r.data)).catch(() => {}); }, []);
  if (!verse) return null;
  return (
    <div className="rounded-2xl border border-[#3D5844]/25 bg-[#3D5844] text-[#FAF7EE] p-8 fade-up" data-testid="daily-verse">
      <div className="flex items-center gap-2 text-[#FAF7EE]/80">
        <BookOpen className="w-4 h-4" />
        <span className="text-xs font-semibold uppercase tracking-[0.2em]">Verse of the Day · KJV</span>
      </div>
      <p className="font-heading text-2xl sm:text-3xl leading-snug mt-4">"{verse.text}"</p>
      <p className="mt-4 text-[#FAF7EE]/85 font-medium">— {verse.ref}</p>
    </div>
  );
}
